import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";

const BASE = process.env.REACT_APP_API_BASE || "http://localhost/twinpack/php";

const S = {
  wrap: { padding: "0 24px 24px" },
  card: {
    background: "#fff", borderRadius: 14, border: "1.5px solid #f0e6ec",
    boxShadow: "0 1px 4px rgba(0,0,0,0.07)", padding: 24, marginTop: 24,
  },
  title: { fontSize: 15, fontWeight: 700, color: "#222", marginBottom: 4 },
  sub:   { fontSize: 13, color: "#888", marginBottom: 20 },
  addRow: { display: "flex", gap: 10, marginBottom: 24 },
  input: {
    flex: 1,
    padding: "9px 12px",
    border: "1.5px solid #e0d6dc",
    borderRadius: 8,
    fontSize: 14,
    outline: "none",
    color: "#222",
  },
  btnAdd: {
    background: "#9f0059",
    color: "#fff",
    border: "none",
    borderRadius: 8,
    padding: "9px 20px",
    fontSize: 14,
    fontWeight: 700,
    cursor: "pointer",
  },
  table: { width: "100%", borderCollapse: "collapse", fontSize: 13 },
  th: {
    background: "#f7f4f6",
    color: "#666",
    fontWeight: 700,
    padding: "9px 12px",
    textAlign: "left",
    borderBottom: "1.5px solid #f0e6ec",
    fontSize: 11,
    textTransform: "uppercase",
    letterSpacing: "0.05em",
  },
  td: {
    padding: "10px 12px",
    borderBottom: "1px solid #f0e6ec",
    color: "#333",
    verticalAlign: "middle",
  },
  editInput: {
    padding: "5px 8px",
    border: "1.5px solid #9f0059",
    borderRadius: 6,
    fontSize: 13,
    outline: "none",
    width: "100%",
  },
  btnIcon: {
    background: "none",
    border: "none",
    cursor: "pointer",
    padding: "4px 8px",
    borderRadius: 6,
    fontSize: 13,
    fontWeight: 700,
  },
  empty: { textAlign: "center", padding: "32px", color: "#aaa", fontSize: 13 },
};

const MotivosRechazoAdmin = () => {
  const [motivos,   setMotivos]   = useState([]);
  const [nuevo,     setNuevo]     = useState("");
  const [editId,    setEditId]    = useState(null);
  const [editText,  setEditText]  = useState("");
  const [saving,    setSaving]    = useState(false);

  const cargar = () => {
    axios.post(`${BASE}/motivos_rechazo_listar.php`)
      .then(r => setMotivos(Array.isArray(r.data) ? r.data : []))
      .catch(() => {});
  };

  useEffect(() => { cargar(); }, []);

  const handleAgregar = async () => {
    if (!nuevo.trim()) { toast.error("Escribí un motivo."); return; }
    setSaving(true);
    try {
      const res = await axios.post(`${BASE}/motivos_rechazo_guardar.php`, new URLSearchParams({ motivo: nuevo.trim() }));
      if (res.data?.success) {
        toast.success("Motivo agregado");
        setNuevo("");
        cargar();
      } else toast.error(res.data?.mensaje || "Error al guardar");
    } catch { toast.error("Error de conexión"); }
    setSaving(false);
  };

  const handleEditar = async (id) => {
    if (!editText.trim()) { toast.error("El motivo no puede estar vacío."); return; }
    try {
      const res = await axios.post(`${BASE}/motivos_rechazo_editar.php`, new URLSearchParams({ id, motivo: editText.trim() }));
      if (res.data?.success) {
        toast.success("Motivo actualizado");
        setEditId(null);
        cargar();
      } else toast.error(res.data?.mensaje || "Error");
    } catch { toast.error("Error de conexión"); }
  };

  const handleEliminar = async (id, motivo) => {
    if (!window.confirm(`¿Eliminar el motivo "${motivo}"?`)) return;
    try {
      const res = await axios.post(`${BASE}/motivos_rechazo_eliminar.php`, new URLSearchParams({ id }));
      if (res.data?.success) { toast.success("Motivo eliminado"); cargar(); }
      else toast.error(res.data?.mensaje || "Error");
    } catch { toast.error("Error de conexión"); }
  };

  return (
    <div style={S.wrap}>
      <div style={S.card}>
        <p style={S.title}>Motivos de rechazo</p>
        <p style={S.sub}>Motivos disponibles al rechazar una cotización o solicitud.</p>
        <div>
          {/* Agregar nuevo */}
          <div style={S.addRow}>
            <input
              style={S.input}
              placeholder="Nuevo motivo de rechazo..."
              value={nuevo}
              onChange={e => setNuevo(e.target.value)}
              onKeyDown={e => e.key === "Enter" && handleAgregar()}
            />
            <button style={{ ...S.btnAdd, opacity: saving ? 0.6 : 1 }} onClick={handleAgregar} disabled={saving}>
              + Agregar
            </button>
          </div>

          {/* Tabla */}
          {motivos.length === 0 ? (
            <p style={S.empty}>No hay motivos configurados.</p>
          ) : (
            <table style={S.table}>
              <thead>
                <tr>
                  <th style={S.th}>#</th>
                  <th style={S.th}>Motivo</th>
                  <th style={{ ...S.th, textAlign: "right" }}>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {motivos.map((m, i) => (
                  <tr key={m.id} style={{ background: i % 2 === 0 ? "#fff" : "#fdf8fb" }}>
                    <td style={{ ...S.td, color: "#aaa", width: 40 }}>{m.id}</td>
                    <td style={S.td}>
                      {editId === m.id ? (
                        <input
                          style={S.editInput}
                          value={editText}
                          onChange={e => setEditText(e.target.value)}
                          onKeyDown={e => {
                            if (e.key === "Enter") handleEditar(m.id);
                            if (e.key === "Escape") setEditId(null);
                          }}
                          autoFocus
                        />
                      ) : (
                        <span style={{ fontWeight: m.motivo === "Otro" ? 600 : 400 }}>{m.motivo}</span>
                      )}
                    </td>
                    <td style={{ ...S.td, textAlign: "right", whiteSpace: "nowrap" }}>
                      {editId === m.id ? (
                        <>
                          <button style={{ ...S.btnIcon, color: "#9f0059" }} onClick={() => handleEditar(m.id)}>✓ Guardar</button>
                          <button style={{ ...S.btnIcon, color: "#888" }} onClick={() => setEditId(null)}>✕</button>
                        </>
                      ) : (
                        <>
                          <button
                            style={{ ...S.btnIcon, color: "#555" }}
                            onClick={() => { setEditId(m.id); setEditText(m.motivo); }}
                            title="Editar"
                          >
                            ✏️
                          </button>
                          <button
                            style={{ ...S.btnIcon, color: "#dc2626" }}
                            onClick={() => handleEliminar(m.id, m.motivo)}
                            title="Eliminar"
                          >
                            🗑
                          </button>
                        </>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};


export default MotivosRechazoAdmin;
